<template>
  <div class="relative">
    <base-input
      :inset="inset"
      :disabled="disabled"
      :with-label="inset"
      id="kode_gudang"
      :label="inset ? 'Kode Gudang' : ''"
      type="text"
      :placeholder="placeholder"
      :shadow="inset"
      v-model="warehouse.searchCode"
      @change="onSearchWarehouse"
    />
    <button
      v-if="!disabled"
      type="button"
      :class="[
        'absolute cursor-pointer text-gray-400',
        inset ? 'right-4 top-6' : '',
      ]"
      :style="inset ? {} : { top: '10px', right: '10px' }"
      @click="onOpenWarehouseModal"
    >
      <Icon class="h-5 w-5" icon="heroicons:magnifying-glass-circle-20-solid" />
    </button>

    <warehouse-table-modal
      v-if="modalType === 'warehouse'"
      :visible="visibleWarehouseModal"
      :warehouse-type="warehouseType"
      @close="visibleWarehouseModal = false"
      @click-warehouse="onChangeWarehouse"
    />

    <OfficeTableModal
      v-else
      :office-type="officeType"
      :columns="['warehouse']"
      :visible="visibleWarehouseModal"
      @close="visibleWarehouseModal = false"
      @click-office="onChangeOffice"
    />

    <loading v-if="loading" />
  </div>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import WarehouseTableModal from './warehouse-table-modal.vue';
import OfficeTableModal from '../office/office-table-modal.vue';

export default {
  components: { WarehouseTableModal, OfficeTableModal },
  mixins: [requestMixin],
  props: {
    value: Object,
    disabled: Boolean,
    inset: {
      type: Boolean,
      default: true,
    },
    warehouseType: {
      type: String,
      default: 'pusat,kantor_pelayanan',
    },
    officeType: {
      type: String,
      default: 'all'
    },
    modalType: {
      type: String,
      default: 'warehouse',
    },
    withArea: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'GDSC1'
    }
  },
  emits: ['input', 'change'],
  data() {
    return {
      loading: false,
      visibleWarehouseModal: false,
    };
  },
  computed: {
    warehouse: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onOpenWarehouseModal() {
      this.visibleWarehouseModal = true;
    },
    async onChangeWarehouse(warehouse) {
      this.warehouse.searchCode = warehouse.attributes.code;

      await this.onSearchWarehouse();

      this.visibleWarehouseModal = false;
    },
    async onChangeOffice(simpleOffice, offices) {
      const office = this.getSingleIncluded(
        offices,
        simpleOffice.relationships.office.data.id
      );
      const warehouse = this.getSingleIncluded(
        offices,
        office.relationships['current-warehouse'].data.id
      );

      this.warehouse.searchCode = warehouse.attributes.code;

      await this.onSearchWarehouse();

      this.visibleWarehouseModal = false;
    },
    async onSearchWarehouse() {
      this.loading = true;

      const [res, err] = await this.request('/api/v1/warehouses', {
        params: {
          'filter[warehouse_type]': this.warehouseType,
          'filter[code]': this.warehouse.searchCode.split(' ')[0],
          'fields[warehouses]': 'code,name,area,current_office_id',
          'fields[areas]': 'code',
          include: 'area',
        },
      });

      if (err || !res.data.length) {
        this.warehouse.searchCode = this.warehouse.originalCode;
      } else {
        const warehouse = res.data[0];

        this.warehouse.id = warehouse.id;
        this.warehouse.code = warehouse.attributes.code;
        this.warehouse.name = warehouse.attributes.name;

        if (this.warehouse.officeId !== undefined) {
          this.warehouse.officeId = warehouse.attributes.current_office_id
        }

        if (this.withArea) {
          const area = this.getSingleIncluded(
            res,
            warehouse.relationships.area.data.id
          );

          this.warehouse.area.id = area.id;
          this.warehouse.area.code = area.attributes.code;

          this.warehouse.searchCode = `${warehouse.attributes.code} (${area.attributes.code})`;
          this.warehouse.originalCode = `${warehouse.attributes.code} (${area.attributes.code})`;
        } else {
          this.warehouse.searchCode = warehouse.attributes.code;
          this.warehouse.originalCode = warehouse.attributes.code;
        }

        this.$emit('change');
      }

      this.loading = false;
    },
  },
};
</script>
